import React                  from 'react';
import PropTypes              from 'prop-types';
import Translations           from '../../../../../utils/Translations';
import {getTopUpGteThenValue} from '../../../../Dailybonus/dailyBonusHelpers';
import {getCurrencySymbol}    from '../../../../../utils/CommonUtils.js';

const DailyBonusVideoVoucherDescription = (props) => (
	<div>
		<div className='dailybonus__mobile--item__description -condensed'>
			{Translations.get('VideoVoucher')}
		</div>
		<div className='dailybonus__mobile--item__description--condition'>
			{Translations.get('MessengerGift365Minimum', getTopUpGteThenValue(props.conditions))} {getCurrencySymbol()}
		</div>
	</div>
);

DailyBonusVideoVoucherDescription.propTypes = {
	conditions: PropTypes.array,
};

export default DailyBonusVideoVoucherDescription;
